<div>
  <div class="d-flex justify-content-between mb-3">
      <p class="f-16 font-weight-500 text-black mb-0">Select Continent</p>
      <div>
          <span><i class="fas fa-times pointer"></i></span>
      </div>

  </div>
  <div class="d-flex mb-4">
      <div>
          <div class="region-box mb-1  pointer"
              [ngClass]="{'border-blue': showregion === 'north america',  'border-gray': showregion !== 'north america'}"
              style="margin-right: 18px;" (click)="selectRegion('north america')">
              <img src="../../assets/images/north-america.png" class="img-fluid w-100" alt="">
          </div>
          <p class="text-black f-14 mb-0">North America</p>
      </div>
      <div>
          <div class="region-box  mb-1 pointer"
              [ngClass]="{'border-blue': showregion === 'asia',  'border-gray': showregion !== 'asia'}"
              (click)="selectRegion('asia')">
              <img src="../../assets/images/asia.png" class="img-fluid w-100" alt="">
          </div>
          <p class="text-black f-14 mb-0">Asia</p>
      </div>
  </div>
  <div class="d-flex mb-4">
      <div>
          <div class="region-box mb-1 pointer"
              [ngClass]="{'border-blue': showregion === 'south america', 'border-gray': showregion !== 'south america'}"
              style="margin-right: 18px;" (click)="selectRegion('south america')">
              <img src="../../assets/images/south-america.png" class="img-fluid w-100" alt="">
          </div>
          <p class="text-black f-14 mb-0">South America</p>
      </div>
      <div>
          <div class="region-box border-gray mb-1 pointer"
              [ngClass]="{'border-blue': showregion === 'africa', 'border-gray': showregion !== 'africa'}"
              style="margin-right: 18px;" (click)="selectRegion('africa')">
              <img src="../../assets/images/africa.png" class="img-fluid w-100" alt="">
          </div>
          <p class="text-black f-14 mb-0">Africa</p>
      </div>
  </div>
  <div class="d-flex">
      <div>
          <div class="region-box mb-1 pointer"
              [ngClass]="{'border-blue': showregion === 'oceania', 'border-gray': showregion !== 'oceania'}"
              style="margin-right: 18px;" (click)="selectRegion('oceania')">
              <img src="../../assets/images/oceania.png" class="img-fluid w-100" alt="">
          </div>
          <p class="text-black f-14 mb-0">Oceania</p>
      </div>
      <div *ngIf="(isTalentInsightsTab && hasEUTalentInsights == 1) || (!isTalentInsightsTab && hasEUAccess && !isAISourcingTab) || (isAISourcingTab && haseuaisourcingaccess)">
        <div class="region-box border-gray mb-1 pointer"
            [ngClass]="{'border-blue': showregion === 'europe', 'border-gray': showregion !== 'europe'}"
            style="margin-right: 18px;" (click)="selectRegion('europe')">
            <img src="../../assets/images/europe.png" class="img-fluid w-100" alt="" style="height: 76px;">
        </div>
        <p class="text-black f-14 mb-0">Europe</p>
    </div>
  </div>
</div>
